/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Assetmanagerenabled2Inputs */

const en_entity_assetmanagerenabled2 = /** @type {(inputs: Entity_Assetmanagerenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset Manager Enabled`)
};

const de_entity_assetmanagerenabled2 = /** @type {(inputs: Entity_Assetmanagerenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset Manager aktiviert`)
};

/**
* | output |
* | --- |
* | "Asset Manager Enabled" |
*
* @param {Entity_Assetmanagerenabled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_assetmanagerenabled2 = /** @type {((inputs?: Entity_Assetmanagerenabled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Assetmanagerenabled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_assetmanagerenabled2(inputs)
	return de_entity_assetmanagerenabled2(inputs)
});
export { entity_assetmanagerenabled2 as "entity_assetManagerEnabled" }